import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { createSingleDataReducer, singleDataType } from '../factories/ApiCall';
import type {
  BackupAction,
  BackupMessageResponse,
  BackupNowParameters,
  BackupSettingsParameters,
  BackupSettingsResponse,
  BackupState,
} from '../types/Backup';

/*
 * action types
 */

const types = {
  BACKUP_SETTINGS: 'SERVER/BACKUP_SETTINGS',
  SAVE_BACKUP_SETTINGS: 'SERVER/SAVE_BACKUP_SETTINGS',
  BACKUP_NOW: 'SERVER/BACKUP_NOW',
} as const;

/*
 * action creators
 */

const actions = {
  loadBackupSettings: (): BackupAction => ({ type: types.BACKUP_SETTINGS }),
  saveBackupSettings: (
    settings: BackupSettingsParameters
  ): BackupAction<BackupSettingsParameters> => ({
    type: types.SAVE_BACKUP_SETTINGS,
    payload: settings,
  }),
  backupNow: (
    settings: BackupNowParameters
  ): BackupAction<BackupNowParameters> => ({
    type: types.BACKUP_NOW,
    payload: settings,
  }),
};

/*
 * state shape
 */
const propType = PropTypes.shape({
  backup_settings: singleDataType,
  backup_settings_save: singleDataType,
  backup_now: singleDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  backup_settings: createSingleDataReducer<BackupSettingsResponse>(
    types.BACKUP_SETTINGS
  ),
  backup_settings_save: createSingleDataReducer<
    BackupMessageResponse,
    BackupSettingsParameters
  >(types.SAVE_BACKUP_SETTINGS),
  backup_now: createSingleDataReducer<
    BackupMessageResponse,
    BackupNowParameters
  >(types.BACKUP_NOW),
}) as (state: BackupState | undefined, action: BackupAction) => BackupState;

export {
  types as actionTypes,
  actions as default,
  propType,
  //  selectors,
  reducer,
};
